import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { store } from 'flow/configure-store';
import { setAppEmbedded } from 'flow/actions/embedded-app-actions';
import EmbeddedType from 'flow/types/embedded-type';
import { isTheOnlyRegistration } from 'flow/utils/instance-count-utils';
import { disconnectApp } from 'flow/actions/navigate-actions';
import { isEmbeddedTypeCti } from 'flow/utils/app-utils';
import { tooManyInstances } from 'flow/actions/cti-actions';
import { allowMultipleInstancesOnOpen } from 'flow/utils/cti-config-utils';
import { addGeneralLogEntry, getQueryParam } from 'flow/utils/browser-utils';
import { setCTIApiHost } from 'flow/utils/is-integration';
import { UserRegionContext } from 'flow/contexts/UserRegionProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var EmbedApplication = /*#__PURE__*/function (_React$PureComponent) {
  function EmbedApplication(props) {
    var _this;
    _classCallCheck(this, EmbedApplication);
    _this = _callSuper(this, EmbedApplication, [props]);
    _this.state = {
      redirect: false
    };
    return _this;
  }
  _inherits(EmbedApplication, _React$PureComponent);
  return _createClass(EmbedApplication, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$context;
      var _this$props = this.props,
        params = _this$props.match.params,
        location = _this$props.location;
      var embeddedType = EmbeddedType.get(params.type);
      (_this$context = this.context) === null || _this$context === void 0 || _this$context.setEmbedType(embeddedType);
      if (embeddedType) {
        store.dispatch(setAppEmbedded(embeddedType));
        this.setState({
          redirect: true
        }); // eslint-disable-line react/no-did-mount-set-state

        if (isEmbeddedTypeCti(embeddedType)) {
          setCTIApiHost();
          var search = location.search;
          var hostDescription = getQueryParam(search, 'config');
          var isNotTheOnlyRegistration = !isTheOnlyRegistration();
          var doesNotAllowMultipleRegistrationsOnOpen = !allowMultipleInstancesOnOpen(hostDescription);
          var redirectToLogin = isNotTheOnlyRegistration && doesNotAllowMultipleRegistrationsOnOpen;
          if (redirectToLogin) {
            store.dispatch(disconnectApp(embeddedType, false))["catch"](function (error) {
              addGeneralLogEntry("Error in disconnect app: ".concat(error));
            });
            store.dispatch(tooManyInstances(true));
          }
        }
      } else {
        console.warn("Failed to embed application of type: ".concat(params.type));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var params = this.props.match.params;
      if (this.state.redirect) {
        return /*#__PURE__*/_jsx(Redirect, {
          to: "/".concat((params[0] || '') + window.location.search)
        });
      }
      return null;
    }
  }]);
}(React.PureComponent);
_defineProperty(EmbedApplication, "contextType", UserRegionContext);
_defineProperty(EmbedApplication, "propTypes", {
  match: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  location: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
});
export default EmbedApplication;